export const getActivitySetsByRef = (state) => {
  return state.activitySets.byRef;
};
